export default __webpack_public_path__ + "static/media/kawa.e9dddfa1.webp";